import { css } from '@linaria/core';

export const voyagerRootVars = css`
  :global() {
    :root {
      --voyager-color-primary: #440f95;
      --voyager-color-tertiary: #f1f1f1;
      --voyager-color-navigationAndFooter: #333333;
      --voyager-color-header: #f4f4f4;
      --voyager-color-sectionTitle: #919191;
      --voyager-color-black: #0d0d0d;
      --voyager-color-white: #ffffff;
      --voyager-color-offWhite: #f1f1f1;
      --voyager-heading-font: 'PP Eiko', 'Playfair Display', serif;
      --voyager-body-font: 'Suisse Intl', 'Inter', sans-serif;
    }
  }
`;
